import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { zendoStorage } from '../../../hybrid/wrappers';
import UserContext, { StoreContext } from '../../../common/utils/getContext';
import Modal from '../RegionAndCurrencySwitcherModal/RegionAndCurrencySwitcherModal';
import ReactCountryFlag from 'react-country-flag';
import Skeleton from '../../plug/Skeleton/Skeleton';
import PropTypes from 'prop-types';
import RegionAndCurrencySwitcherConfirm from '../RegionAndCurrencySwitcherConfirm/RegionAndCurrencySwitcherConfirm';
import css from './RegionAndCurrencySwitcher.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../common/utils/styles';

const RegionAndCurrencySwitcher = ({ mode, compStyle }) => {
    let { localization, currencies, lang, activeLangs, settings } = useContext(UserContext);
    const { classes } = generateCompStylers(compStyle);
    const isStorePage = useContext(StoreContext);

    // For MacOS Catalina Safari
    if (typeof localization === 'string') {
        localization = JSON.parse(localization);
    }

    const ref = useRef();

    const activeLanguage = useMemo(
        () =>
            activeLangs &&
            (activeLangs?.find((language) => language.alias === lang) ||
                activeLangs?.find((language) => language.isDefault) ||
                null),
        [activeLangs, lang]
    );

    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [isShowPortalModal, setIsShowPortalModal] = useState(false);

    useEffect(() => {
        if (localization.country?.id) {
            if (!zendoStorage.get('localization')) {
                zendoStorage.set('localization', JSON.stringify(localization));
                setIsShowConfirmModal(true);
            }
        }

        return () => setIsShowConfirmModal(false);
    }, [lang, localization, localization?.country?.id]);

    const viewOfCurrency = useMemo(() => {
        const userCurrency = currencies?.data?.find((el) => el.code === localization?.currency);
        return settings?.currency_format == 0 || settings?.currency_format == 1 ? userCurrency?.code : userCurrency?.code;
    }, [localization.currency, currencies, settings?.currency_format]);

    const RenderData = () => {
        return (
            <div
                onClick={() => setIsShowPortalModal((pre) => !pre)}
                className={mode === 'light' ? css.regionsLangButtonLight : css.regionsLangButton}
            >
                <div className={css.menuLangMargin}>
                    <div className={css.menuLangsWrapper}>
                        <div className={mode === 'light' ? css.menuLangSwitcherDesktopLight : css.menuLangSwitcherDesktop}>
                            <div className={css.menuLangSwitcherLangFlag}>
                                {activeLanguage && localization?.country?.code ? (
                                    <p className={css.menuLangSwitcherFlag}>
                                        <ReactCountryFlag
                                            svg
                                            countryCode={localization?.country?.code}
                                            style={{
                                                objectFit: 'cover',
                                                width: '100%',
                                                height: '100%'
                                            }}
                                        />
                                    </p>
                                ) : (
                                    <p className={css.menuLangSwitcherNameDesktop}>{activeLanguage?.alias || lang}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className={classnames(css.wrapper, mode === 'light' ? css.wrapperLight : null, classes.wrapper)}>
                        <span className={css.languageText}>{activeLanguage?.name}</span>
                        {/* {activeLanguage?.name ? ', ' : ''} */}
                        <span className={css.currencyAddon}>{viewOfCurrency}</span>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className={css.positionRelative} ref={ref}>
            <Skeleton
                Component={RenderData}
                wrapperStyles={{ width: '10rem' }}
                wait={Boolean(localization?.country?.code)}
                elements={[
                    {
                        mode: 'light',
                        type: 'blockSM',
                        gap: [1, 0, 1, 0]
                    }
                ]}
            />
            {isShowPortalModal && (
                <Modal
                    isStorePage={isStorePage}
                    setIsShowConfirmModal={setIsShowConfirmModal}
                    setIsShowPortalModal={setIsShowPortalModal}
                />
            )}
            {isShowConfirmModal ? (
                <RegionAndCurrencySwitcherConfirm
                    mode={mode}
                    setIsShowPortalModal={setIsShowPortalModal}
                    setIsShowConfirmModal={setIsShowConfirmModal}
                    blockRef={ref}
                />
            ) : null}
        </div>
    );
};
RegionAndCurrencySwitcher.propTypes = {
    styles: PropTypes.object,
    mode: PropTypes.oneOf(['light', 'left'])
};
export default RegionAndCurrencySwitcher;
